import { _debounce } from '@/utils/common'

export const RuleRangeList = (list, index) => ({
  trigger: 'change',
  validator: _debounce(validateRangeList, 200),
  list,
  index
})

function validateRangeList (rule, value, callback) {
  switch (value.type) {
    // 区间
    case 0:
      if (value.min >= value.max) {
        return callback(new Error('左右区间不能相等，且左区间不能大于右区间'))
      }
      break
    case 1:
    case 2:
    case 3:
    case 4:
      // 大于 大于等于  需要遍历整个数组是否有两个大于
      for (let i = 0; i < rule.list.length; i++) {
        if (i === rule.index) {
          break
        }
        if (rule.list[i].type === value.type) {
          return callback(new Error('不能有两个大于或两个小于'))
        }
      }
      break
  }
  callback()
}
